module.exports = __webpack_public_path__ + "static/img/zhongxin.589c3a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongxin.jpg
// module id = 254
// module chunks = 10 18 21 22 25